import script from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=js"

import "./DualRangeSlider.vue?vue&type=style&index=0&id=24b8a2cc&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b8a2cc"]])

export default __exports__